class BaseApiService {
    _apiRoutes;
    _apiHttpService;

    constructor(apiRoutes, apiHttpService) {
        this._apiRoutes = apiRoutes;
        this._apiHttpService = apiHttpService;
    }
}

export { BaseApiService };
